import React, {Component} from "react";

import {
    Jumbotron,
    Alert,
    Pagination,
    PaginationItem,
    PaginationLink
} from 'reactstrap';

import RenderTemplate from "./lists/RenderTemplate";

import Nav from '../../components/nav/Nav';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {
    getRisksResponse,
    getRisks
} from '../../actions/risks';

import {
    getRisks as getRisksService
} from '../../services/risk';

import Spinner from '../../components/spinner/Spinner';
import env from "../../env";

class List  extends Component{

    constructor(props) {

        super(props);

        this.state = {
            list: null,
            loading: true,
            site: null,
            error: null,
            template_id: ''
        };
    }

    componentWillReceiveProps(nextProps){

        const {loading, error, list} = nextProps.risks;

        this.setState({loading,error,list});
    }

    initRisks = (page, template) => {

        const {site} = this.props.account;
        const {template_id} = this.state;

        let type = template || template === ''? template : template_id;

        console.log(type);
        let props = this.props;
        let mine_id = site? site.id: null;

        props.getRisks();

        getRisksService({mine_id, page, template_id: type}).then(function(resp){
            props.getRisksResponse(resp);
        }).catch(function(e){
            console.log(e);
        });

        this.setState({
            site
        });
    };

    componentDidMount(){

        const {loggedIn, site} = this.props.account;
        const {list} = this.state;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }

        if(site === null || !site)
            this.props.history.push(`${env.url}/`);

        let page = list && list.current_page? list.current_page : 1;

        this.initRisks(page);
    }

    navigate = (page) => {
        this.initRisks(page);
    };

    onChange = (event) => {
        let template_id = event.target.value;
        this.setState({template_id});

        const {list} = this.state;
        let page = list && list.current_page? list.current_page : 1;

        this.initRisks(page, template_id)
    };

    render(){

        const templates = {
            'occupational_health': 'Occupational health and safety template',
            'management_of_change': 'MOC (Management of Change)',
            'ergonomic': 'Ergonomic template',
            'biological': 'Biological template',
            'environmental': 'Environmental template',
            'asbestos': 'Asbestos template',
            'route_risk_assessment': 'Route risk assessment template'
        };

        const {
            list,
            loading,
            site,
            error,
            template_id
        } = this.state;

        let risks = [];
        let last_page = 1;
        let pages = [];
        let current_page = 1;

        if(list && list.data){
            risks = list.data;
            last_page = list.last_page;
            current_page = list.current_page;
            for(let i = 0; i < last_page; i++){
                pages.push(i+1);
            }
        }


        return(
            <div className="checklists risks-lists">
                <Nav
                    history={this.props.history}
                    location={this.props.location}/>
                {
                    error?
                        <Alert color="danger">{error}</Alert>:null
                }


                {
                    loading?
                        <Spinner/>
                        :
                        (
                            <div>
                                <Jumbotron>
                                    <p className="lead">
                                        {site? site.name : ''} Risk Dashboards
                                    </p>
                                    <hr className="my-2" />
                                    <p>Click on a risk view details</p>
                                </Jumbotron>

                                <div className="inner">

                                    <div className="list">
                                        {
                                            risks && risks.length > 0?
                                                (
                                                    <div>
                                                        <div className="col-xs-12">
                                                            <div className="form-group">
                                                                <label
                                                                    htmlFor="template_id"
                                                                    className="control-label">
                                                                    Select Template
                                                                </label>
                                                                <select
                                                                    value={template_id}
                                                                    onChange={this.onChange}
                                                                    className="selectpicker form-control"
                                                                    id="template_id"
                                                                    name="template_id">
                                                                    <option value="">Select an option</option>
                                                                    {
                                                                        Object.keys(templates).map(key => <option key={key} value={key}>{templates[key]}</option>)
                                                                    }
                                                                </select>

                                                            </div>
                                                        </div>

                                                        {
                                                            risks.map((risk, key) => (
                                                                <div key={key}>
                                                                    {
                                                                        <RenderTemplate risk={risk} data={risk.data}/>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                        {
                                                            last_page && last_page > 1?
                                                                (
                                                                    <Pagination aria-label="Risks navigation">
                                                                        <PaginationItem disabled={current_page === 1}>
                                                                            <PaginationLink onClick={() => this.navigate(current_page - 1)} previous href="javascript:void(0)" />
                                                                        </PaginationItem>

                                                                        {
                                                                            pages.map(page => (
                                                                                <PaginationItem key={page} active={page === current_page}>
                                                                                    <PaginationLink onClick={() => this.navigate(page)} href="javascript:void(0)">
                                                                                        {page}
                                                                                    </PaginationLink>
                                                                                </PaginationItem>
                                                                            ))
                                                                        }
                                                                        <PaginationItem disabled={current_page === last_page}>
                                                                            <PaginationLink onClick={() => this.navigate(current_page + 1)} next href="javascript:void(0)" />
                                                                        </PaginationItem>

                                                                    </Pagination>
                                                                ):(<p/>)
                                                        }
                                                    </div>
                                                )
                                                    :
                                                (
                                                    <p className='nothing'>No Risks available</p>
                                                )

                                        }

                                    </div>
                                </div>
                            </div>
                        )
                }

            </div>
        )
    }
}


const mapStateToProps = ({ account, risks}) => ({
    account,
    risks
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getRisksResponse: (resp) => getRisksResponse(resp),
    getRisks: () => getRisks()
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List)




// WEBPACK FOOTER //
// ./src/screens/risks/List.js